import { takeLatest, spawn, put, call } from 'redux-saga/effects';
import { appActions } from '../../reducer';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { get, post } from '../../../utils/api';
import { paymentActions, PAYMENT } from './reducer';
import { getItemInStorage } from '../../../utils/functions';

const MySwal = withReactContent(Swal)

function* createPayment(action: any): any {
    try {
        const { paymentControls } = action;
        const body = {
            invoiceIds: paymentControls.selectedInvoices.map((invoice: any) => invoice.id),
            amount: paymentControls.amount,
            effectiveDate: paymentControls.effectiveDate,
            paymentConcept: paymentControls.paymentConcept,
            paymentForm: paymentControls.paymentForm,
            destinationAccountNum: paymentControls.destinationAccountNum,
            destinationRfc: paymentControls.destinationRfc,
            sourceAccountNum: paymentControls.sourceAccountNum,
            sourceRfc: paymentControls.sourceRfc,
            sourceForeignName: paymentControls.sourceForeignName,
        }
        console.log('Body:', body);
        const response = yield call(post, '/invoice/payment', body);
        console.log('API response:', response);

        if(response.error) {
            yield put(paymentActions.createPaymentFailed());
            let errorMessage = '';
            try {
                const parsed = typeof response.errorMsg === 'string' ? JSON.parse(response.errorMsg) : response.errorMsg;
                errorMessage = parsed?.error?.message || parsed?.message || response.errorMsg;
            } catch (e) {
                errorMessage = response.errorMsg;
            }
            MySwal.fire({
                icon: 'error',
                title: `Ooops, tenemos problemas para generar tu complemento de pago`,
                text: errorMessage,
            })
        } else {
            yield put(paymentActions.createPaymentSuccess(response));
            MySwal.fire({
                icon: 'success',
                title: `El complemento de pago se ha generado con éxito`,
                text: response.errorMsg,
            })
        }

    } catch (error) {
        console.error('Error creating payment:', error);
        yield put(paymentActions.createPaymentFailed());
    }
}

export default function* paymentSaga() {
    yield takeLatest(PAYMENT.CREATE_PAYMENT, createPayment);
}